import { createFileRoute, redirect } from '@tanstack/react-router';
import { requireFeature } from '@/common/utils/requireFeature';
import { FeatureKey } from '@/common/enums/feature-keys.enum';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { PlaybookDetailView } from '@/features/playbooks/components/PlaybookDetailView';

/** UUID v7 do banco não segue o nibble de variant RFC — validação permissiva. */
const PLAYBOOK_ID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const RESERVED_PLAYBOOK_SLUGS = new Set([
  'new',
  'config',
  'templates',
  'tasks',
  'my-steps',
  'steps',
  'process-types',
]);

export const Route = createFileRoute('/_authenticated/playbooks/$id')({
  beforeLoad: async ({ params }) => {
    await requireFeature(FeatureKey.CLIENT_PLAYBOOKS);
    const id = params.id.toLowerCase();
    if (RESERVED_PLAYBOOK_SLUGS.has(id) || !PLAYBOOK_ID_REGEX.test(id)) {
      throw redirect({ to: '/playbooks', search: { status: 'in_progress' } });
    }
  },
  component: PlaybookDetailPage,
});

function PlaybookDetailPage() {
  const { id } = Route.useParams();
  return (
    <PermissionGate permission={Permission.PLAYBOOKS_VIEW}>
      <PlaybookDetailView playbookId={id} />
    </PermissionGate>
  );
}
